/* global mixpanel */
import _groupBy from 'lodash/groupBy'
import _values from 'lodash/values'
import _keyBy from 'lodash/keyBy'
import _map from 'lodash/map'
import _without from 'lodash/without'

function makeCategoryCount (items, categories) { // helper function to create categories count summary
  let result = { }
  let groupedObj = _groupBy(items, 'category_id')
  let groupedArr = _values(groupedObj)
  let categoriesMap = _keyBy(categories, 'id')
  groupedArr.map((item) => {
    const categoryId = item[0].category_id
    const categoryName = !categoriesMap[categoryId] ? categoryId : categoriesMap[categoryId].name
    result[categoryName] = item.length
  })
  return result
}

export function libraryTaxStart ({currOutlet}) {
  mixpanel.track('Library Tax Start', {
    'Current Selected Outlet': currOutlet
  })
}

export function libraryChangeOutlet ({currOutlet}) {
  mixpanel.track('Library Tax Change Outlet', {
    'Current Selected Outlet': currOutlet
  })
}

export function libraryCreateTax ({tax, isAllOutlet, taxDetail, categories}) { // to modify for item tax
  const eventName = isAllOutlet ? 'Library Tax Create All Outlet' : 'Library Tax Create One Outlet'
  const countAssigned = makeCategoryCount(taxDetail.items, categories)
  mixpanel.track(eventName, {
    'Name': tax.name,
    'Value': tax.amount,
    'Summary Assigned Items': countAssigned
  })
}

export function libraryUpdateOneOutlet ({newName}, taxDetail, categories) {
  const newCountAssigned = makeCategoryCount(taxDetail.items, categories)
  const oldCountAssigned = makeCategoryCount(taxDetail.org_items, categories)
  mixpanel.track('Library Tax Update One Outlet', {
    'Old Name': taxDetail.name,
    'Old Value': taxDetail.amount,
    'New Name': newName.name,
    'New Value': newName.amount,
    'Old Summary Assigned Items': oldCountAssigned,
    'New Summary Assigned Items': newCountAssigned
  })
}

export function libraryDeleteTax ({tax, taxDetail, categories}) {
  const countAssigned = makeCategoryCount(taxDetail.items, categories)
  mixpanel.track('Library Tax Delete', {
    'Name': tax.name,
    'Value': tax.amount,
    'Summary Assigned Items': countAssigned
  })
}

export function libraryTaxCreateAssignItemCancel () {
  mixpanel.track('Library Tax Create Assign Item Cancel')
}

export function libraryTaxEditAssignItemCancel () {
  mixpanel.track('Library Tax Edit Assign Item Cancel')
}

export function libraryTaxCreateAssignItemStart (outletId) {
  mixpanel.track('Library Tax Create Assign Item Start', {
    'outlet_id': outletId
  })
}

export function libraryTaxEditAssignItemStart (outletId) {
  mixpanel.track('Library Tax Edit Assign Item Start', {
    'outlet_id': outletId
  })
}

export function libraryTaxCreateAssignItemApply (taxDetail) {
  const itemIds = _without(_map(taxDetail.items, 'item_id'), undefined)
  mixpanel.track('Library Tax Create Assign Item Apply', {
    'Count': itemIds.length
  })
}

export function libraryTaxEditAssignItemApply (taxDetail) {
  const itemIds = _without(_map(taxDetail.items, 'item_id'), undefined)
  mixpanel.track('Library Tax Edit Assign Item Apply', {
    'Count': itemIds.length
  })
}

export function libraryTaxCreateAssignItemAssignAll (taxDetail, categoryId, keyword) {
  const itemIds = _without(_map(taxDetail.items, 'item_id'), undefined)
  mixpanel.track('Library Tax Create Assign Item Assign All', {
    'Category': categoryId,
    'Keyword': keyword,
    'Count': itemIds.length
  })
}

export function libraryTaxEditAssignItemAssignAll (taxDetail, categoryId, keyword) {
  const itemIds = _without(_map(taxDetail.items, 'item_id'), undefined)
  mixpanel.track('Library Tax Edit Assign Item Assign All', {
    'Category': categoryId,
    'Keyword': keyword,
    'Count': itemIds.length
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/tax.js